// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uJUe","colBig":"styles_colBig__3-52R","colSmall":"styles_colSmall__s_nf_"};